export const DEFAULT_TESTIMONIAL_AVATAR = "/ImageAndVideo/image/careimg5.jpg";

export const normalizeTestimonialStatus = (item) => {
  const rawApproved =
    item?.isApproved ??
    item?.IsApproved ??
    item?.is_approved ??
    item?.approved ??
    item?.Approved;

  switch (Number(rawApproved)) {
    case 0:
      return "pending";

    case 1:
      return "approved";

    case 2:
      return "rejected";

    default:
      return "pending";
  }
};
export const normalizeTestimonials = (response) => {
  const items = Array.isArray(response)
    ? response
    : Array.isArray(response?.Data)
    ? response.Data
    : Array.isArray(response?.data)
    ? response.data
    : Array.isArray(response?.items)
    ? response.items
    : Array.isArray(response?.Items)
    ? response.Items
    : [];

  if (!Array.isArray(items)) {
    return [];
  }

  return items.map((item) => ({
    id: item.testimonialId ?? item.TestimonialId ?? item.id ?? item.Id ?? `t-${Math.random()}`,
    fullName: item.fullName ?? item.FullName ?? item.full_name ?? "",
    email: item.email ?? item.Email ?? "",
    company: item.companyName ?? item.CompanyName ?? item.company ?? item.Company ?? "",
    city: item.city ?? item.City ?? "Delhi NCR",
    rating: item.rating ?? item.Rating ?? 5,
    message: item.review ?? item.Review ?? item.message ?? item.Message ?? "",
    photo: item.imageUrl ?? item.ImageUrl ?? item.photo ?? item.Photo ?? DEFAULT_TESTIMONIAL_AVATAR,
    verified: Boolean(item.isApproved ?? item.IsApproved ?? item.verified ?? item.Verified),
    status: normalizeTestimonialStatus(item),
    createdAt: item.createdAt ?? item.CreatedAt ?? item.created_at ?? new Date().toISOString(),
  }));
};

export const normalizeBookings = (response) => {
  const items = Array.isArray(response)
    ? response
    : Array.isArray(response?.Data)
    ? response.Data
    : Array.isArray(response?.data)
    ? response.data
    : [];

  if (!Array.isArray(items)) {
    return [];
  }

  return items.map((booking) => ({
    id: booking.bookingId ?? booking.id ?? booking.bookingID ?? "",
    patientName: booking.patientName ?? booking.patient_name ?? booking.patient?.name ?? "",
    mobile: booking.mobile ?? booking.phone ?? booking.contactNo ?? "",
    consultantType: booking.bookingType ?? booking.consultationType ?? booking.serviceType ?? "",
    visitPrice: booking.visitPrice ?? booking.price ?? booking.fee ?? "",
    department: booking.department ?? booking.departmentName ?? booking.specialty ?? "",
    doctor: booking.specialist ?? booking.doctor ?? booking.doctorName ?? "",
    bookingDate: booking.date ?? booking.bookingDate ?? booking.appointmentDate ?? "",
    time: booking.slot ?? booking.time ?? booking.visitTiming ?? "",
    status: booking.status ?? booking.bookingStatus ?? "Pending",
    raw: booking,
  }));
};

export const isApiSuccess = (response) => response?.success !== false && response?.Success !== false;
